import BaseInputTextWithCounter from "./BaseInputTextWithCounter.vue";

export default BaseInputTextWithCounter;
